<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="reports-container">
  @for (report of filteredReports; track report) {
    <div class="col-lg-4 col-md-6 report-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ report.name }}</h5>
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p><strong>Izvještajno razdoblje:</strong> Od {{ report.reportingPeriodStart | date: 'd.M.yyyy.' }} Do {{ report.reportingPeriodEnd| date: 'd.M.yyyy.' }} </p>
          <p><strong>Datum predaje:</strong> {{ report.submittedAt | date: 'd.M.yyyy. HH:mm:ss' }}</p>
          <p>
            <strong>Status:</strong>
                    <span class="daxa-badge" [ngClass]="{
                      'blue': report.status === ProjectReportStatus.Draft || report.status === ProjectReportStatus.Returned,
                      'yellow': report.status === ProjectReportStatus.Submitted || report.status === ProjectReportStatus.Resubmitted,
                      'green': report.status === ProjectReportStatus.Approved,
                      'red': report.status === ProjectReportStatus.Rejected
                    }">
              {{ report.userFriendlyStatus }}
            </span>
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Pregledaj izvještaj" (click)="goToViewReport(report)">
            <mat-icon>visibility</mat-icon>
          </button>
          @if (report.isActionAllowed('Return')) {
            <button mat-icon-button color="primary" matTooltip="Vrati izvještaj na doradu" (click)="confirmReturn(report)">
              <mat-icon>reply</mat-icon>
            </button>
          }
          @if (report.isActionAllowed('Approve')) {
            <button mat-icon-button color="primary" matTooltip="Odobri izvještaj" (click)="confirmApprove(report)">
              <mat-icon>check_circle</mat-icon>
            </button>
          }
          @if (report.isActionAllowed('Reject')) {
            <button mat-icon-button color="warn" matTooltip="Odbij izvještaj" (click)="confirmReject(report)">
              <mat-icon>cancel</mat-icon>
            </button>
          }
          <button mat-icon-button color="primary" matTooltip="Preuzmi izvještaj" (click)="downloadReport(report)">
            <mat-icon>download</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>
